export default __webpack_public_path__ + "static/media/cat.163d3c06.svg";